import { useConfig } from '@features/configs/hooks/use-config';

import { CAMPAIGN_CONFIG_TYPE, Campaign, toCampaign } from '../services/campaigns';

/**
 * Fetches a single campaign by id. Passing undefined keeps the query disabled,
 * so this is safe to call from components that are not always on a campaign route.
 */
export function useCampaign(campaignId: string | undefined) {
  const query = useConfig(campaignId, CAMPAIGN_CONFIG_TYPE);
  const campaign: Campaign | undefined = query.data ? toCampaign(query.data) : undefined;

  return { ...query, campaign };
}
